module.exports = __webpack_public_path__ + "iveco.ce63486e57ba53b79a68.png";